import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonModule} from '@adnova/jf-ng-components';
import {PrivacyPolicyContentComponent} from './privacy-policy-content.component';
import {VersionNoticeComponent} from './version-notice/version-notice.component';


@NgModule({
    declarations: [
        PrivacyPolicyContentComponent,
        VersionNoticeComponent
    ],
    exports: [
        PrivacyPolicyContentComponent,
        VersionNoticeComponent
    ],
    imports: [
        CommonModule,
        ButtonModule
    ]
})
export class PrivacyPolicyContentModule { }
